/* global BigInt */
import * as React from 'react';
import { formatEther } from 'viem';
import { NftCard } from './NftCard';
import { MintList } from './MintList';

export function Cart(props) {
  const [value, setValue] = React.useState(0n);
  const [ethValue, setEthValue] = React.useState('0');

  React.useEffect(() => {
    const qty = BigInt(props.cart?.length || 0);
    let bigPrice = 0n;
    try {
      bigPrice =
        typeof props.bigPrice === 'bigint'
          ? props.bigPrice
          : BigInt(props.bigPrice || 0);
    } catch (_e) {
      bigPrice = 0n;
    }
    const totalValue = qty * bigPrice;
    setValue(totalValue);
    try {
      setEthValue(formatEther(totalValue));
    } catch (_e) {
      setEthValue('0');
    }
  }, [props.cart, props.bigPrice]);

  return (
    <>
      <div className='grid grid-cols-3 md:grid-cols-5 xl:grid-cols-8 gap-4'>
        {props.cart &&
          props.cart.map((id) => (
            <NftCard
              key={id}
              id={id}
              removeFromCart={props.removeFromCart}
              cart={props.cart}
              inCart={props.inCart}
              bigPrice={props.bigPrice}
              inCartStatus={props.inCartStatus}
            />
          ))}
      </div>
      <MintList
        cart={props.cart}
        value={value}
        connected={props.connected}
        eth={ethValue}
        resetCart={props.resetCart}
      />
    </>
  );
}
